import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  Table,
  Pagination,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import {
  searchLeadByName,
  getallDonorVoucherList,
  DeleteVoucherDoner,
} from "../../../Listfunction";
import Card from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import LoadingSpinner from "views/Components/loadingSpinner";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import SweetAlert from "react-bootstrap-sweetalert";
import Datetime from "react-datetime";
import moment from "moment";

class DonorVoucher extends Component {
  constructor(props) {
    super(props);
    this.state = {
      donorList: [],
      page: 1,
      paginationData: [],
      nextpage: "",
      prevpage: "",
      currentPage: 1,
      nextdisabled: "1",
      prevdisabled: "1",
      loading: false,
      _notificationSystem: null,
      useraccess: "",
      noRecordFound: false,
      totpageNo: "",
      created_at: "",
      alert: null,
    };
    this.onChange = this.onChange.bind(this);
    this.SearchDate = this.SearchDate.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.resetSearch = this.resetSearch.bind(this);
    this.paginationinfo = this.paginationinfo.bind(this);
    this.addVoucherDoner = this.addVoucherDoner.bind(this);
  }

  resetSearch(e) {
    this.setState({
      created_at: "",
      page: 1,
    });

    setTimeout(
      function () {
        this.SearchDate(1);
      }.bind(this),
      1000
    );
  }

  SearchDate = (page) => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    var date = "";
    if (this.state.created_at == "" || this.state.created_at == null) {
      date = "";
    } else {
      var date = moment(this.state.created_at).format("YYYY-MM-DD");
    }

    getallDonorVoucherList(date, page, obj)
      .then((res) => {
        if (res.data.success == true) {
          var data = res.data.data;

          var no_pages = [];
          let serach_string = "";
          for (var i = 1; i <= data.last_page; i++) {
            if (serach_string == "") {
              no_pages.push(i);
            } else {
              no_pages.push(i);
            }
          }

          if (data.current_page == data.last_page) {
            this.setState({ prevdisabled: null });
            this.setState({ nextdisabled: "1" });
          } else if (data.current_page == 1) {
            this.setState({ nextdisabled: null });
            this.setState({ prevdisabled: "1" });
          } else {
            this.setState({ nextdisabled: null });
            this.setState({ prevdisabled: null });
          }
          if (data.last_page == 1) {
            this.setState({ nextdisabled: 1 });
            this.setState({ prevdisabled: 1 });
          }
          if (data.length == 0) {
            no_pages = [];
            this.setState({ nextdisabled: 1 });
            this.setState({ prevdisabled: 1 });
          }
          this.setState({ currentPage: data.current_page });
          if (data.next_page_url != null) {
            if (serach_string == "") {
              this.setState({
                nextpage: data.next_page_url.substring(
                  data.next_page_url.indexOf("=") + 1
                ),
              });
            } else {
              this.setState({
                nextpage: data.next_page_url.substring(
                  data.next_page_url.indexOf("=") + 1
                ),
              });
            }
          } else {
            this.setState({ nextpage: "#" });
          }
          if (data.prev_page_url != null) {
            if (serach_string == "") {
              this.setState({
                prevpage: data.prev_page_url.substring(
                  data.prev_page_url.indexOf("=") + 1
                ),
              });
            } else {
              this.setState({
                prevpage: data.prev_page_url.substring(
                  data.prev_page_url.indexOf("=") + 1
                ),
              });
            }
          } else {
            this.setState({ prevpage: "#" });
          }

          this.setState({
            loading: false,
            donorList: res.data.data.data,
            totpageNo: data.last_page,
            paginationData: no_pages,
          });
        }
      })
      .catch((err) => {
        this.handleNetworkError("bl");
      });
  };

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleSuccess(position, message) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: <div>{message}</div>,
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  handleClick(position, message) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>{message}</b>
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  handleNetworkError(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Network Error</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  componentDidMount() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    this.setState({
      useraccess: token.role,
    });

    this.SearchDate(1);
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700
    );
  }

  handleChange = (e) => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    searchLeadByName(e.target.value, obj).then((response) => {
      var data = response.data.data;
      var table_data = [];

      for (let i = 0; i < data.length; i++) {
        var detail = {
          value: data[i].id,
          label: data[i].lead_name,
        };
        table_data.push(detail);
      }
      this.setState({
        patient_list: table_data,
      });
    });
  };

  paginationinfo(url) {
    this.SearchDate(url);
  }

  addVoucherDoner = () => {
    this.props.history.push("/admin/addvcrdonor");
  };

  warningWithConfirmAndCancelMessage(id) {
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          //title="Are you sure?"
          onConfirm={() => this.deleteVoucher(id)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes, delete it!"
          cancelBtnText="Cancel"
          showCancel
        >
          Are you sure you want to delete this voucher donor?
        </SweetAlert>
      ),
    });
  }

  deleteVoucher(id) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    DeleteVoucherDoner(obj, id)
      .then(() => {
        this.setState({
          alert: null,
        });
        this.SearchDate(this.state.page);
        this.handleSuccess("bl", "Voucher Donor deleted successfully.");
      })
      .catch((error) => {
        this.handleNetworkError("bl");
      });
  }

  hideAlert() {
    this.setState({
      alert: null,
    });
  }

  render() {
    var c = 1;
    const remove = <Tooltip id="remove">Remove</Tooltip>;

    return (
      <div className="main-content">
        <Grid fluid>
          {this.state.alert}
          <NotificationSystem ref="notificationSystem" style={style} />
          <Row>
            <Col md={12}>
              <Card
                tableFullWidth
                content={
                  <Row>
                    <Col className="text-right" style={{ padding: "4px 28px" }}>
                      <Button
                        className="btn-fill"
                        fill
                        style={{ backgroundColor: "#2b3a41" }}
                        onClick={this.addVoucherDoner.bind(this)}
                      >
                        {" "}
                        Add <i className="fa fa-plus"></i>
                      </Button>{" "}
                    </Col>

                    <Col className="consultation_filter_container">
                      <Row>
                        <Col
                          md={4}
                          sm={6}
                          className="consultation_filter_display"
                        >
                          <Datetime
                            dateFormat="DD/MM/YYYY"
                            timeFormat={false}
                            inputProps={{ placeholder: "Created Date" }}
                            closeOnSelect={true}
                            value={this.state.created_at}
                            onChange={(val) => {
                              this.setState({
                                created_at: val,
                              });
                            }}
                          />
                        </Col>
                        <Col style={{ margin: "0.4rem" }}>
                          <Button
                            class="btn-color" //bsStyle="info"
                            fill
                            onClick={this.SearchDate.bind(this, 1)}
                          >
                            Filter
                          </Button>
                          &nbsp;&nbsp;
                          <Button
                            class="btn-color" //bsStyle="info"
                            fill
                            onClick={this.resetSearch.bind(this)}
                          >
                            Reset
                          </Button>
                        </Col>
                      </Row>
                    </Col>

                    <Col md={12} className="consultation_tabledate_container">
                      <Table responsive>
                        <thead>
                          <tr>
                            <th>Donor ID</th>
                            <th>Donor Name</th>
                            <th>Donor Contact</th>
                            <th>Price</th>
                            <th>Payment Method</th>
                            <th>Payment Date</th>
                            <th>Payment Status</th>
                            <th>Created Date</th>
                            <th className="text-right">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.loading ? (
                            <tr>
                              <td colspan="10">
                                <LoadingSpinner />
                              </td>
                            </tr>
                          ) : this.state.donorList.length == 0 ? (
                            <tr>
                              <td colspan="10">
                                <center>No record found</center>
                              </td>
                            </tr>
                          ) : (
                            <React.Fragment>
                              {this.state.donorList.map((cus, i) =>
                                cus.doner ? (
                                  <tr key={i}>
                                    <td>{cus.doner_id}</td>
                                    <td
                                      key={i}
                                      style={{ textTransform: "capitalize" }}
                                    >
                                      {cus.doner.name}
                                    </td>
                                    <td>
                                      {cus.doner.mobile_no
                                        ? cus.doner.mobile_no
                                        : "-"}
                                    </td>
                                    <td>{cus.price ? cus.price : "-"}</td>
                                    <td>
                                      {cus.payment_method
                                        ? cus.payment_method == 1
                                          ? "Cash"
                                          : cus.payment_method == 2
                                          ? "Card"
                                          : cus.payment_method == 3
                                          ? "Bank Transfer"
                                          : ""
                                        : "-"}
                                    </td>
                                    <td>
                                      {cus.payment_date
                                        ? cus.payment_date
                                        : "-"}
                                    </td>
                                    <td style={{ textTransform: "capitalize" }}>
                                      {cus.payment_status ? (
                                        cus.payment_status
                                      ) : (
                                        <p class="btn btn-fill fl_text_orange">
                                          Recharge
                                        </p>
                                      )}
                                    </td>
                                    <td>{cus.created_at}</td>
                                    {
                                      <td className="td-actions text-right no-padding">
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={remove}
                                        >
                                          <Button
                                            simple
                                            bsStyle="danger"
                                            onClick={this.warningWithConfirmAndCancelMessage.bind(
                                              this,
                                              cus.id
                                            )}
                                            bsSize="xs"
                                          >
                                            <i className="fa fa-times" />
                                          </Button>
                                        </OverlayTrigger>
                                      </td>
                                    }
                                  </tr>
                                ) : (
                                  " "
                                )
                              )}
                            </React.Fragment>
                          )}
                        </tbody>
                      </Table>

                      {this.state.loading
                        ? ""
                        : this.state.noRecordFound
                        ? ""
                        : this.state.totpageNo > 1 && (
                            <div style={{ textAlign: "center" }}>
                              <Pagination>
                                <Pagination.First
                                  onClick={this.paginationinfo.bind(
                                    this,
                                    this.state.prevpage
                                  )}
                                  disabled={this.state.prevdisabled}
                                />
                                {this.state.paginationData.map((url) => (
                                  <Pagination.Item
                                    active={
                                      this.state.currentPage == c ? "1" : null
                                    }
                                    onClick={this.paginationinfo.bind(
                                      this,
                                      url
                                    )}
                                  >
                                    {c++}
                                  </Pagination.Item>
                                ))}
                                <Pagination.Last
                                  onClick={this.paginationinfo.bind(
                                    this,
                                    this.state.nextpage
                                  )}
                                  disabled={this.state.nextdisabled}
                                />
                              </Pagination>
                            </div>
                          )}
                    </Col>
                  </Row>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default DonorVoucher;
